<mat-form-field appearance="outline" class="full-width">
    <!-- <mat-label>{{ label }}</mat-label> -->
    <textarea matInput [placeholder]="placeholder" [rows]="rows" [cols]="cols" [disabled]="disabled"
        [required]="required" [formControl]="control"></textarea>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
</mat-form-field>